<template>
        <transition name="fade">
            <div :class="['live-event-notification', {'-event-starting' : isEventStarting }, {'-event-running' : isEventRunning }]"
                v-if="isEventNotification && !isDigitalClassRoom"
            >
                <router-link :to="getRouteToCourse(course)" class="router-link">
                    <span v-html="notificationTextPart1"></span> {{ course.title }} <span v-html="notificationTextPart2"></span>
                </router-link>
                <span @click="hideNotification" class="icon-clear"></span>
            </div>
        </transition>
</template>

<script>
    import routeHelper from 'components/shared/mixins/routeHelper'
    import { mapGetters } from 'vuex'

    export default {
        name: 'live-event-notification',
        mixins: [ routeHelper ],
        props: {
            eventStatus: String,
            course: Object
        },
        data () {
            return {
                showNotification: true
            }
        },
        computed: {
            ...mapGetters({
                isDigitalClassRoomTraining: 'Courses/isDigitalClassRoomTraining'
            }),
            isDigitalClassRoom () {
                return this.isDigitalClassRoomTraining(this.course)
            },
            isEventNotification () {
                return this.eventStatus !== null && this.showNotification
            },
            isEventStarting () {
                return this.eventStatus === 'starting'
            },
            isEventRunning () {
                return this.eventStatus === 'running'
            },
            notificationTextPart1 () {
                return this.isEventStarting ? this.$t('LiveEventNotification.event_starting_part_1') : this.$t('LiveEventNotification.event_running_part_1')
            },
            notificationTextPart2 () {
                return this.isEventStarting ? this.$t('LiveEventNotification.event_starting_part_2') : this.$t('LiveEventNotification.event_running_part_2')
            }
        },
        methods: {
            hideNotification () {
                this.showNotification = false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .icon-clear {
        position: absolute;
        right: 10px;
        bottom: 10px;
    }

    .router-link {
        display: flex;
        align-items: center;
    }

    .live-event-notification {
        position: fixed;
        height: 60px;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        right: 0;
        max-width: 1170px;
        color: $black;
        font-size: 1.8rem;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: stretch;
        z-index: 4;
        transition: all 1s ease;
        text-align: center;
        padding: 10px 20px;

        [class*="desktop"] & {
            height: 90px;
        }

        &.-event-starting {
            background-color: $honeysuckle;
        }

        &.-event-running {
            background-color: $magic_mint;
        }

        .fade-enter-active, .fade-leave-active {
            transition: opacity .5s;
        }

        .fade-enter, .fade-leave-to {
            opacity: 0;
        }
    }
</style>
